import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { fetcher } from '$shared/fetch';
import { ORGANIZATION_SETTINGS_PATH } from '$shared/utils/api-paths';

export interface OrganizationSettings {
  timezone: string;
}

const settingsQueryKey = ['organization-settings'];

export const createGetOrganizationSettingsQuery = () => ({
  queryKey: settingsQueryKey,
  queryFn: () => fetcher.get<OrganizationSettings>(ORGANIZATION_SETTINGS_PATH),
});

export const useOrganizationSettings = () =>
  useQuery(createGetOrganizationSettingsQuery());

export const useUpdateOrganizationSettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (settings: OrganizationSettings) =>
      fetcher.patch<OrganizationSettings, OrganizationSettings>(
        ORGANIZATION_SETTINGS_PATH,
        settings,
      ),
    onSuccess: (settings) => queryClient.setQueryData(settingsQueryKey, settings),
  });
};
